export default "__VITE_ASSET__BPJ6wJuW__"